import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Snaps the window back to the top on every client-side route change.
 *
 * SPA navigation preserves the scroll position by default, so following a link from a
 * deep-scrolled page (e.g. the home page) into /donate, /thank-you or /sign-in
 * would land the new page mid-scroll. Rendered once inside <Router>, above the routes.
 */
const ScrollToTop: React.FC = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // `auto` = instant snap (not smooth) so the new page is at the top the moment it renders.
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [pathname]);

  return null;
};

export default ScrollToTop;
